import { render } from "./Notification.vue?vue&type=template&id=5e128969&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=5e128969&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e128969"

export default script